export default 'https://tme.understood.org/assets/spider-lane.9b631a34.lottie'